module.exports = __webpack_public_path__ + "static/media/yellow_nebula_LF.d0c7b68b.png";